import axios from 'axios';
import {
    Message,
    MessageBox
} from 'element-ui'
import Router from '@/router'
// 基本配置
// 本机 taiguo.com 已含 MINI/casino/lottery 等最新 gamelist 逻辑；admin.u66888.com 为旧代码会返回空
// export const API_BASE_URL = 'http://taiguo.com/';
export const API_BASE_URL = 'https://admin.u66888.com/';
const instance = axios.create({
  	baseURL: API_BASE_URL,
	// baseURL: window.location.origin,
  	timeout: 100000 // 设置超时时间，单位为ms
});

// 请求拦截器
instance.interceptors.request.use(config => {
  config.headers['token'] = localStorage.getItem('token'); // 设置请求头部分，这里举例使用了localStorage存储的token作为身份标识
  config.headers['lang'] = localStorage.getItem('languageTow') || 'th';
  return config;
}, error => {
  console.log(error);
  return Promise.reject(error);
});
 
// 响应拦截器
instance.interceptors.response.use(response => {
  const data = response.data;
  if (data && data.status && data.status.errorCode == 401) {
	  localStorage.removeItem('token');
	  localStorage.removeItem('siteTitle');
	  localStorage.removeItem('siteIco');
	  if (localStorage.getItem('languageTow')) {
	  	localStorage.removeItem('languageTow');
	  }
	  if (localStorage.getItem('language')) {
	  	localStorage.removeItem('language');
	  }
	  if (localStorage.getItem('userInfo')) {
	  	localStorage.removeItem('userInfo');
	  }
	  if (localStorage.getItem('tongjilistTow')) {
	  	localStorage.removeItem('tongjilistTow');
	  }
	  // 登录/注册页不要被踢回首页，避免「进注册又跳首页」
	  const path = (window.location && window.location.pathname) || '';
	  if (path === '/login' || path === '/register') {
	  	return Promise.reject(data);
	  }
	  location.href='/';
	  return;
	  // 根据接口返回的状态码判断是否有错误
	  // Message({
		 //  message: '请先登录!',
		 //  type: 'error',
		 //  duration: 1.5 * 1000,
		 //  showClose:true
	  // })// 自定义错误提示
	  // setTimeout(function(){
		 //  Router.push('/')
	  // },1000)
   //    return Promise.reject(new Error(data.message));
	  // Router.push('/')
	  // return Promise.resolve(data)
  } else {
      return data;
  }
}, error => {
  console.log(error);
  return Promise.reject(error);
});
 
export default instance;
